import {
    Box,
    Button,
    FormControlLabel,
    FormLabel,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material"
import {CheckBox, Close as CloseIcon} from "@mui/icons-material"
import {useState} from "react"
import PropTypes from "prop-types"
import {UserAdminMode} from "./index"

const styles = {
    root: {
        maxWidth: '800px',
        background: 'white',
        boxShadow: 'rgb(0, 0, 0) 1px 1px 3px',
        borderRadius: '1rem',
        overflow: 'hidden',
        width: '60%'
    },
    headerBox: {
        display: 'flex',
        alignItems: 'center',
        padding: '1rem',
        background: 'rgb(238, 238, 238)',
        justifyContent: 'space-between',
        borderStyle: 'none none inset none',
        borderColor: '#333',
        borderWidth: '0.5px'
    },
    formBox: {
        padding: '1rem',
        maxHeight: '700px',
        overflow: 'scroll',
        display: "flex",
        flexDirection: "row",
    },
    formLeftBox: {
        flexGrow: 1,
    },
    formRightBox: {
        flexGrow: 1,
    },
    footerBox: {
        padding: '1rem',
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        justifyContent: 'end',
    }
}

const UserAdminEditorView = ({mode, user, onClose, onChange}) => {

    const [areaList, setAreaList] = useState([])

    return (
        <Box style={styles.root}>
            <Box style={styles.headerBox}>
                <Typography>ユーザ{mode === UserAdminMode.NewUser ? "登録" : "編集"}</Typography>
                <Box>
                    <IconButton>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Box>
            <Box style={styles.formBox}>
                <Box style={styles.formLeftBox}>
                    <Box>
                        <Box>名前</Box>
                        <Box><TextField /></Box>
                    </Box>
                    <Box>
                        <Box>メールアドレス</Box>
                        <Box><TextField /></Box>
                    </Box>
                    <Box>
                        <Box>パスワード</Box>
                        <Box><TextField /></Box>
                    </Box>
                    <Box>
                        <Box>パスワード再入力</Box>
                        <Box><TextField /></Box>
                    </Box>
                    <Box>
                        <Box>認証用電話番号</Box>
                        <Box><TextField /></Box>
                    </Box>

                </Box>
                <Box style={styles.formRightBox}>
                    <Box>
                        <Box>所属</Box>
                        <Box>
                            <Select variant="outlined">
                                <MenuItem>ほげ</MenuItem>
                                <MenuItem>ふが</MenuItem>
                            </Select>
                        </Box>
                    </Box>
                    <Box>
                        <Box>エリア</Box>
                        <Box>
                            {user?.area_codes?.map(code => {
                                const area = areaList.find(o => o.code === code)
                                if (!area) { return null }
                                return (
                                    <Box>
                                        <Typography>{area.name}</Typography>
                                        <IconButton size="small">
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>
                                )
                            })}
                            <Box>
                                <Select variant="outlined">
                                    {areaList.map(o => (
                                        <MenuItem value={o.code}>{o.name}</MenuItem>
                                    ))}
                                </Select>
                                <Button size="small" variant="outlined">追加</Button>
                            </Box>
                        </Box>
                    </Box>
                    <Box>
                        <Box>権限</Box>
                        <Box>
                            <FormControlLabel control={<CheckBox />} label="管理権限" />
                            <Box>
                                <Box>アプリ権限</Box>
                                <Box>
                                    <Select variant="outlined">
                                        <MenuItem>なし</MenuItem>
                                        <MenuItem>閲覧</MenuItem>
                                        <MenuItem>編集</MenuItem>
                                    </Select>
                                </Box>
                            </Box>
                            <Box>
                                <Box>ウェブ権限</Box>
                                <Box>
                                    <Select variant="outlined">
                                        <MenuItem>なし</MenuItem>
                                        <MenuItem>閲覧</MenuItem>
                                        <MenuItem>編集</MenuItem>
                                    </Select>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>



            </Box>
            <Box style={styles.footerBox}>
                <Button variant="contained">登録</Button>
                <Button variant="contained">リセット</Button>
            </Box>
        </Box>
    )

}

UserAdminEditorView.propTypes = {
    user: PropTypes.object,
    mode: PropTypes.string,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
}

export default UserAdminEditorView
